import 'react';
import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import useObservableBoxValue from '../../hooks/mobx/use-observable-box-value.js';
import usePipeline from './use-pipeline.js';

function useIsPiping() {
  var pipeline = usePipeline();

  var _useObservableBoxValu = useObservableBoxValue(pipeline.isPiping),
      _useObservableBoxValu2 = _slicedToArray(_useObservableBoxValu, 1),
      isPiping = _useObservableBoxValu2[0];

  return isPiping;
}

export default useIsPiping;
//# sourceMappingURL=use-is-piping.js.map
